/**
 * アプリケーション設定
 */

// 環境に応じたAPI URLの設定
const environments = {
  development: {
    API_URI: 'https://develop.fitspace.co.jp',
  },
  staging: {
    API_URI: 'https://staging.fitspace.co.jp',
  },
  production: {
    API_URI: 'https://fitspace.co.jp',
  },
};

// 現在の環境を取得（デフォルトは開発環境）
const env = process.env.NODE_ENV || 'development';

// API通信の共通設定
export const fetchConfig = {
  method: 'get',
  mode: 'cors' as RequestMode,
  credentials: 'include' as RequestCredentials,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': 'true',
  },
};

// 環境に対応する設定をエクスポート
export default environments[env as keyof typeof environments]; 